import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  linkShowMore: {
    id: 'link.showMore',
    defaultMessage: 'Show more',
    description: 'Text on link that is shown when there are more columns hidden in section',
  },
});
